import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdListItemColumns = _resolveComponent("AdListItemColumns")!
  const _component_AdListItemFullScreen = _resolveComponent("AdListItemFullScreen")!
  const _component_AdListItemTable = _resolveComponent("AdListItemTable")!
  const _component_AdListItemMobile = _resolveComponent("AdListItemMobile")!
  const _component_AdListItemRows = _resolveComponent("AdListItemRows")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'AdDetail', params: { adFrontId: _ctx.ad.adFrontId } },
    custom: ""
  }, {
    default: _withCtx(({ href }) => [
      _createElementVNode("a", {
        href: href,
        target: "_blank",
        class: "estate-listing__item",
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onMouseOver())),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMouseLeave())),
        ref: "element"
      }, [
        (_ctx.viewType === 'columns')
          ? (_openBlock(), _createBlock(_component_AdListItemColumns, {
              key: 0,
              class: _normalizeClass({ 'is-active': _ctx.isActive }),
              ad: _ctx.ad,
              imageLimitCount: _ctx.imageLimitCount
            }, null, 8, ["class", "ad", "imageLimitCount"]))
          : (_ctx.viewType === 'fullscreen')
            ? (_openBlock(), _createBlock(_component_AdListItemFullScreen, {
                key: 1,
                class: _normalizeClass({ 'is-active': _ctx.isActive }),
                ad: _ctx.ad,
                imageLimitCount: _ctx.imageLimitCount
              }, null, 8, ["class", "ad", "imageLimitCount"]))
            : (_ctx.viewType === 'table')
              ? (_openBlock(), _createBlock(_component_AdListItemTable, {
                  key: 2,
                  class: _normalizeClass({ 'is-active': _ctx.isActive }),
                  ad: _ctx.ad,
                  imageLimitCount: _ctx.imageLimitCount
                }, null, 8, ["class", "ad", "imageLimitCount"]))
              : (_ctx.viewType === 'mobile')
                ? (_openBlock(), _createBlock(_component_AdListItemMobile, {
                    key: 3,
                    class: _normalizeClass({ 'is-active': _ctx.isActive }),
                    ad: _ctx.ad,
                    imageLimitCount: _ctx.imageLimitCount
                  }, null, 8, ["class", "ad", "imageLimitCount"]))
                : (_openBlock(), _createBlock(_component_AdListItemRows, {
                    key: 4,
                    class: _normalizeClass({ 'is-active': _ctx.isActive }),
                    ad: _ctx.ad,
                    imageLimitCount: _ctx.imageLimitCount
                  }, null, 8, ["class", "ad", "imageLimitCount"]))
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to"]))
}